import { collection, onSnapshot, query } from 'firebase/firestore';

import { db } from '@/firebase-config';
import type { Asset } from '@/types';
import { logger } from '@/utils/logger';
import type { UserAssetClient } from '../contracts/user-asset-client';

export class FirebaseUserAssetClient implements UserAssetClient {
  subscribeToUserAssets(userId: string, onUpdate: (assets: Asset[]) => void): () => void {
    if (!userId) {
      logger.warn('No user ID provided for asset subscription');
      return () => {};
    }

    const assetsQuery = query(collection(db, 'users', userId, 'custom_assets'));
    return onSnapshot(assetsQuery, snapshot => {
      const assets: Asset[] = [];
      for (const docSnap of snapshot.docs) {
        assets.push(docSnap.data() as Asset);
      }
      onUpdate(assets);
    }, error => {
      logger.error('Error subscribing to user assets:', error);
    });
  }
}
